import { useCallback, useState, useEffect } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import { Status } from './types';
// Worker version needs to be the same as the pdf.js version
pdfjsLib.GlobalWorkerOptions.workerSrc =
    '//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.7.107/pdf.worker.js';
export const sessionExpiredKey = 'sessionExpired';
const usePdf = () => {
    const [pdfPage, setPdfPage] = useState();
    const [pdfDocument, setPdfDocument] = useState();
    const [error, setError] = useState();
    const [status, setStatus] = useState(Status.init);
    const setLoadingState = useCallback(() => {
        setStatus(Status.loading);
        setError(undefined);
    }, []);
    const setErrorState = useCallback((newError) => {
        setStatus(Status.failure);
        setError(newError);
    }, []);
    const setSuccessState = useCallback(() => {
        setStatus(Status.success);
        setError(undefined);
    }, []);
    const loadPage = useCallback(async (page) => {
        if (!pdfDocument) {
            return;
        }
        const loadingTask = pdfDocument.getPage(page);
        loadingTask
            .then((loadedPage) => {
            setPdfPage(loadedPage);
            setSuccessState();
        })
            .catch((pdfPageError) => {
            setErrorState(pdfPageError);
        });
    }, [pdfDocument, setErrorState, setSuccessState]);
    useEffect(() => {
        loadPage(1);
    }, [loadPage, pdfDocument]);
    const loadPdf = useCallback(async (url) => {
        setLoadingState();
        if (!url) {
            setErrorState(new pdfjsLib.InvalidPDFException('Document not found'));
            return;
        }
        const loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise
            .then((loadedPdf) => {
            setPdfDocument(loadedPdf);
        })
            .catch((pdfDocumentError) => {
            setErrorState(pdfDocumentError);
        });
    }, [setErrorState, setLoadingState]);
    if (error) {
        return {
            loadPdf,
            loadPage,
            status: Status.failure,
            error,
        };
    }
    if (status === Status.success) {
        return {
            loadPdf,
            loadPage,
            status: Status.success,
            // On success, pdfDocument and pdfPare are never `undefined`
            pdfDocument: pdfDocument,
            pdfPage: pdfPage,
        };
    }
    if (status === Status.loading) {
        return { loadPdf, loadPage, status: Status.loading };
    }
    return {
        loadPdf,
        loadPage,
        status: Status.init,
    };
};
export default usePdf;
